(function () {
  const root = document.querySelector('[data-c3]');
  if (!root) return;
  let DATA = [];
  try { DATA = JSON.parse(root.querySelector('[data-c3-data]').textContent); } catch (e) { return; }
  const PCT = Number(root.dataset.pct) || 17;
  const LIVE = root.dataset.live === 'true';
  document.body.classList.add('c3-page');
  const how = root.querySelector('[data-c3-how]');
  // the browser tab should say Bundle & Save even when this layout is shown through another page
  if (!/bundle/i.test(document.title)) document.title = 'Bundle & Save: pick any 3 bags and save | The Swedest Thing';
  const money = (c) => '$' + (c / 100).toFixed(2);
  const grid = root.querySelector('[data-c3-grid]');
  const slots = Array.from(root.querySelectorAll('[data-c3-slot]'));
  const status = root.querySelector('[data-c3-status]');
  const was = root.querySelector('[data-c3-was]');
  const now = root.querySelector('[data-c3-now]');
  const save = root.querySelector('[data-c3-save]');
  const add = root.querySelector('[data-c3-add]');
  const clear = root.querySelector('[data-c3-clear]');
  const monthlyWrap = root.querySelector('[data-c3-monthly]');
  const monthlyBox = root.querySelector('[data-c3-monthly-box]');
  const sizeBtns = Array.from(root.querySelectorAll('[data-c3-size]'));
  let size = 'half';
  const picks = []; // product ids, a flavor can appear more than once
  const byId = new Map(DATA.map((p) => [p.id, p]));
  const sheet = root.querySelector('[data-c3-sheet]');
  const list = root.querySelector('[data-c3-list]');
  const none = root.querySelector('[data-c3-none]');
  const searches = Array.from(root.querySelectorAll('[data-c3-search]'));
  const catBtns = Array.from(root.querySelectorAll('[data-c3-cat]'));
  let query = '';
  let cat = 'all';
  const shown = (p) => (cat === 'all' || p.kind === cat) && (!query || p.title.toLowerCase().indexOf(query) > -1);
  const nm = (p) => p.title.replace(/ Bag$/, '').replace(/"/g, '');
  const label = () => (size === 'half' ? '1/2 lb' : '1 lb');
  const count = (id) => picks.filter((x) => x === id).length;
  const canMonthly = () => picks.length > 0 && picks.every((id) => byId.get(id)[size].plan);

  grid.innerHTML = DATA.map((p) =>
    '<li class="c3__card" data-id="' + p.id + '">' +
      '<a class="c3__img" href="' + p.url + '" tabindex="-1" aria-hidden="true"><img src="' + p.img + '" alt="" loading="lazy" width="180" height="180"></a>' +
      '<p class="c3__kind">' + (p.kind === 'Mix' ? 'Curated mix' : 'Single flavor') + '</p>' +
      '<a class="c3__name" href="' + p.url + '">' + p.title.replace(/ Bag$/, '') + '</a>' +
      '<p class="c3__cardprice" data-price></p>' +
      '<div class="c3__step"><button type="button" data-minus aria-label="Remove one ' + p.title.replace(/"/g, '') + '">&minus;</button><span data-n>0</span><button type="button" data-plus aria-label="Add one ' + p.title.replace(/"/g, '') + '">+</button></div>' +
    '</li>').join('');

  list.innerHTML = DATA.map((p) =>
    '<li class="c3__row" data-id="' + p.id + '">' +
      '<img src="' + p.img + '" alt="" loading="lazy" width="56" height="56">' +
      '<span class="c3__rowtext"><span class="c3__rowname">' + nm(p) + '</span><span class="c3__rowmeta"><span data-price></span> &middot; ' + (p.kind === 'Mix' ? 'Curated mix' : 'Single flavor') + '</span></span>' +
      '<span class="c3__step c3__step--row"><button type="button" data-minus aria-label="Remove one ' + nm(p) + '">&minus;</button><span data-n>0</span><button type="button" data-plus aria-label="Add one ' + nm(p) + '">+</button></span>' +
    '</li>').join('');

  function render() {
    const full = picks.length >= 3;
    let visible = 0;
    list.querySelectorAll('.c3__row').forEach((li) => {
      const p = byId.get(Number(li.dataset.id));
      const v = p[size];
      const n = count(p.id);
      li.hidden = !shown(p);
      li.querySelector('[data-price]').textContent = money(v.price);
      li.querySelector('[data-n]').textContent = n;
      li.classList.toggle('is-picked', n > 0);
      li.querySelector('[data-minus]').disabled = n === 0;
      li.querySelector('[data-plus]').disabled = full || !v.ok;
    });
    sheet.querySelector('[data-c3-sheettitle]').textContent = full ? 'Your 3 bags are picked' : 'Add a bag · ' + picks.length + ' of 3';
    grid.querySelectorAll('.c3__card').forEach((li) => {
      const p = byId.get(Number(li.dataset.id));
      const v = p[size];
      const n = count(p.id);
      li.querySelector('[data-price]').textContent = money(v.price);
      li.querySelector('[data-n]').textContent = n;
      li.classList.toggle('is-picked', n > 0);
      li.querySelector('[data-minus]').disabled = n === 0;
      li.querySelector('[data-plus]').disabled = full || !v.ok;
      li.classList.toggle('is-out', !v.ok);
      li.hidden = !shown(p);
      if (shown(p)) visible++;
    });
    none.hidden = visible > 0;
    slots.forEach((s, i) => {
      const id = picks[i];
      if (id) {
        const p = byId.get(id);
        s.classList.add('is-filled');
        s.innerHTML = '<img src="' + p.img + '" alt="" width="64" height="64"><span>' + p.title.replace(/ Bag$/, '') + '</span><button type="button" data-drop="' + i + '" aria-label="Remove ' + p.title.replace(/"/g, '') + '">&times;</button>';
      } else {
        s.classList.remove('is-filled');
        s.innerHTML = '<button type="button" class="c3__slotadd" data-open-sheet aria-label="Choose a bag"><span class="c3__plus" aria-hidden="true">+</span></button>';
      }
    });
    const total = picks.reduce((sum, id) => sum + byId.get(id)[size].price, 0);
    const monthly = monthlyBox.checked && canMonthly();
    monthlyWrap.hidden = !canMonthly() || !full;
    if (!full) {
      status.textContent = picks.length === 0 ? 'Pick 3 bags' : 'Pick ' + (3 - picks.length) + ' more';
      was.textContent = ''; now.textContent = ''; save.textContent = '';
      if (how) how.textContent = '';
    } else {
      // Shopify takes the percentage off each bag and drops the fraction of a cent, so the quote does the same (3 half-pound bags: $53.97 - $9.15 = $44.82)
      const off = picks.reduce((sum, id) => { const p = byId.get(id)[size].price; return sum + p - Math.floor(p * PCT / 100); }, 0);
      status.textContent = 'Your set of 3 · ' + label() + ' bags';
      if (LIVE) {
        was.textContent = money(total);
        now.textContent = money(monthly ? picks.reduce((s, id) => s + byId.get(id)[size].planPrice, 0) : off);
        save.textContent = 'Save ' + PCT + '%';
        if (how) how.textContent = 'The ' + PCT + '% comes off automatically in your cart.';
      } else {
        was.textContent = '';
        now.textContent = money(total);
        save.textContent = '';
        if (how) how.textContent = 'The ' + PCT + '% Bundle & Save discount is taken off automatically in your cart.';
      }
    }
    add.disabled = !full;
    add.textContent = full ? (monthly ? 'Start my monthly set' : 'Add 3 bags to cart') : 'Add 3 bags to cart';
    clear.hidden = picks.length === 0;
  }

  grid.addEventListener('click', (e) => {
    const li = e.target.closest('.c3__card');
    if (!li) return;
    const id = Number(li.dataset.id);
    if (e.target.closest('[data-plus]') && picks.length < 3) picks.push(id);
    else if (e.target.closest('[data-minus]')) { const i = picks.lastIndexOf(id); if (i > -1) picks.splice(i, 1); }
    else return;
    render();
  });
  root.querySelector('.c3__slots').addEventListener('click', (e) => {
    const b = e.target.closest('[data-drop]');
    if (b) { picks.splice(Number(b.dataset.drop), 1); render(); return; }
    if (e.target.closest('[data-open-sheet]') || e.target.closest('.c3__slot:not(.is-filled)')) openSheet();
  });
  function openSheet() {
    if (picks.length >= 3 || typeof sheet.showModal !== 'function') return;
    sheet.showModal();
    document.body.style.overflow = 'hidden';
  }
  function closeSheet() { if (sheet.open) sheet.close(); }
  sheet.addEventListener('close', () => { document.body.style.overflow = ''; });
  sheet.addEventListener('click', (e) => { if (e.target === sheet) closeSheet(); });
  root.querySelector('[data-c3-sheetclose]').addEventListener('click', closeSheet);
  root.querySelector('[data-c3-sheetdone]').addEventListener('click', closeSheet);
  list.addEventListener('click', (e) => {
    const li = e.target.closest('.c3__row');
    if (!li) return;
    const id = Number(li.dataset.id);
    if (e.target.closest('[data-plus]') && picks.length < 3) picks.push(id);
    else if (e.target.closest('[data-minus]')) { const i = picks.lastIndexOf(id); if (i > -1) picks.splice(i, 1); }
    else return;
    render();
    if (picks.length >= 3) setTimeout(closeSheet, 450);
  });
  searches.forEach((inp) => inp.addEventListener('input', () => {
    query = inp.value.trim().toLowerCase();
    searches.forEach((o) => { if (o !== inp) o.value = inp.value; });
    render();
  }));
  catBtns.forEach((b) => b.addEventListener('click', () => {
    cat = b.dataset.c3Cat;
    catBtns.forEach((x) => x.classList.toggle('is-on', x.dataset.c3Cat === cat));
    render();
  }));
  clear.addEventListener('click', () => { picks.length = 0; render(); });
  monthlyBox.addEventListener('change', render);
  sizeBtns.forEach((b) => b.addEventListener('click', () => {
    size = b.dataset.c3Size;
    sizeBtns.forEach((x) => { const on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
    render();
  }));

  add.addEventListener('click', () => {
    if (picks.length !== 3) return;
    add.disabled = true; add.textContent = 'Adding...';
    const monthly = monthlyBox.checked && canMonthly();
    const setId = 'set' + Date.now().toString(36);
    const grouped = new Map();
    picks.forEach((id) => grouped.set(id, (grouped.get(id) || 0) + 1));
    const items = Array.from(grouped, ([id, q]) => {
      const v = byId.get(id)[size];
      const it = { id: v.id, quantity: q, properties: { 'Bundle & Save': label() + ' set', _bundle_save: setId } };
      if (monthly) it.selling_plan = v.plan;
      return it;
    });
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) })
      .then((r) => { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(() => { window.location.href = '/cart'; })
      .catch(() => { add.disabled = false; add.textContent = 'Could not add, try again'; });
  });

  render();
})();
